module.exports = __webpack_public_path__ + "img/ornament.b2707b91.png";